"use strict";

require("core-js/modules/es.symbol.description");

require("core-js/modules/es.array.iterator");

module.exports = isIterable;

function isIterable(a) {
  return a != null && !!a[Symbol.iterator];
}